<template>
<v-dialog v-model="showRunTasksDialog" id="buckets-update-dialog" width="400">
    <v-card class="pa-4">
      <v-card-title class="ma-0 mb-2 pa-0">
        <h2>Run Tasks</h2>
      </v-card-title>
      <v-card-text class="ma-0 mb-1 pa-0">
        <p>Task runs on every case in the {{bucketName}} bucket.</p>
      </v-card-text>
      <v-flex xs12>
        <v-select
          :items="tasklistNames"
          :disabled="!tasklists"
          label="Tasklist"
          v-model="selectedTasklist"
          item-text="name"
          item-value="id"
          box>
        </v-select>
        </v-flex>
        <v-flex xs12>
        <v-select
          :items="taskNames"
          :disabled="!tasklists"
          label="Task"
          v-model="selectedTask"
          item-text="description"
          item-value="id"
          box>
        </v-select>
      </v-flex>
      <v-card-actions class="ma-0 mb-4 pa-0">
        <v-btn
          :disabled="selectedTask === ''"
          @click="performUpdateTask()"
          id="bucket-update-dialog-confirm-btn"
          color="secondary">
          Run task
        </v-btn>
        <v-btn
          @click="clearUpdateSelections()"
          id="bucket-update-dialog-cancel-btn"
          color="error">
          Cancel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import Helpers from '@/helpers.js'

export default {
  props: {
    showRunTasksDialog: {
      type: Boolean
    },
    bucket: {
      type: Object,
      required: true
    },
    caseTypeId: {
      type: Number,
      required: true
    }
  },
  data: () => ({
    selectedTasklist: "",
    selectedTask: "",
    tasklists: [],
    tasks: []
  }),
  computed: {
    tasklistNames() {
      if (this.tasklists && this.tasklists.length > 0) {
        return this.tasklists.map(item => item.name)
      } else {
        return []
      }
    },
    taskNames() {
      if (this.tasks && this.tasks.length > 0) {
        return this.tasks.map(item => item.description)
      } else {
        return []
      }
    },
    bucketName() {
      return (this.bucket && this.bucket.name) || ""
    }
  },
  mounted() {
    this.getTasklists()
  },
  watch: {
    selectedTasklist() {
      if (!this.tasklists) {
        return
      }
      this.tasklists.forEach(tasklist => {
        if (tasklist.name === this.selectedTasklist) { this.tasks = tasklist.tasks }
      })
    }
  },
  methods: {
    async getTasklists() {
      const caseType = Helpers.getCaseTypeById(this.$store.state, this.caseTypeId)
      this.tasklists = (caseType && caseType.tasklistTemplates) || []
    },
    performUpdateTask() {
      if (!this.tasklists) {
        this.clearUpdateSelections()
        return
      }
      const tasklist = this.tasklists.find((tl) => tl.name === this.selectedTasklist)

      const task = this.tasks.find((t) => t.description === this.selectedTask)

      if (tasklist && task) {
        this.$store.dispatch("executeBucketRunTask", { task, bucket: this.bucket })
      }
      this.clearUpdateSelections()
    },
    clearUpdateSelections() {
      this.selectedTasklist = ""
      this.selectedTask = ""
      this.showUpdateDialog = false
      this.$emit("tasks-dialog-closed")
    }
  }
}
</script>
